import React, { useState, useMemo } from "react"; // MODIFIED: Added useMemo
import "../../../App.css";
import "../Transactions.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

// Import tab components
import WorkforceRequest from "./tabs/WorkforceRequestTab/WorkforceRequest";
import { FEATURES } from "../../../config/features";
import { FinancialRequest } from "../../../v2/components/modules/FinancialRequest/FinancialRequest";
import { EmployeeTransactionRequest } from "../../../v2/components/modules/EmployeeTransactionRequest/EmployeeTransactionRequest";
import { DEV_MODE } from "../../Security";
import { TransactionRequestModule } from "../../../v2/components/modules/TransactionRequest/TransactionReqeustModule";

function RequestApproval({ user, userAccess, isHideSideMenu }) {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleSelectChange = (index) => {
    setSelectedTab(index);
  };

  // --------------------------------------------------------
  // --------------------------------------------------------
  // --------------------------------------------------------
  // use the new way for dev mode
  const isUsingNewWay = true; 
  // --------------------------------------------------------
  // --------------------------------------------------------
  // --------------------------------------------------------

  // ADDED: Configuration-driven tab definitions
  const tabConfigs = useMemo(() => [
    {
      id: 'workforce',
      label: 'WORKFORCE REQUESTS',
      condition: true, // Always show
      component:
        isUsingNewWay
          ? <TransactionRequestModule user={user} userAccess={userAccess} />
          : <WorkforceRequest user={user} userAccess={userAccess} />
    },
    {
      id: 'financial',
      label: 'FINANCIAL REQUESTS',
      condition: FEATURES.REQUEST_APPROVAL__FINANCIAL_REQUESTS,
      component: <FinancialRequest user={user} userAccess={userAccess} />
    },
    {
      id: 'employeeTransaction',
      label: 'EMPLOYEE TRANSACTION REQUESTS',
      condition: FEATURES.REQUEST_APPROVAL__EMPLOYEE_TRANSACTION_REQUESTS,
      component: <EmployeeTransactionRequest user={user} userAccess={userAccess} />
    }
  ], [user, userAccess]);

  // MODIFIED: Filter tabs based on feature flags
  const activeTabs = tabConfigs.filter(tab => tab.condition);

  // Helper for dynamic styling
  const tabStyle = (index) => `px-4 py-2 cursor-pointer font-medium transition-colors outline-none select-none ${selectedTab === index
    ? "bg-[#668fca] text-white rounded-t-lg"
    : "text-[#668fca] hover:text-[#4a6ea5]"
    }`;

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="TransactionInfo shadow-xl">
            <div className="transaction-header">
              <div className="sub-title row">
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                  {"Transactions > "}
                </span>
                <span style={{ borderBottom: "1px solid black" }}>
                  {"Request Approval"}
                </span>
              </div>
              <h3>Request Approval</h3>
            </div>

            <div className="mainData p-5">
              <Tabs
                selectedIndex={selectedTab}
                onSelect={index => handleSelectChange(index)}
                className="react-tabs"
              >
                {/* MODIFIED: Dynamically render Tab Headers */}
                <TabList
                  className="flex flex-row items-center justify-start overflow-x-auto overflow-y-hidden text-sm border-b border-gray-200 mb-4 list-none p-0"
                  style={{ borderBottom: '1px solid #dadce0' }}
                >
                  {activeTabs.map((tab, index) => (
                    <Tab key={tab.id} className={tabStyle(index)}>
                      {tab.label}
                    </Tab>
                  ))}
                </TabList>

                <div className="requestApprovalTab">
                  {/* MODIFIED: Dynamically render Tab Content Panels */}
                  {activeTabs.map((tab) => (
                    <TabPanel key={tab.id}>
                      {tab.component}
                    </TabPanel>
                  ))}
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestApproval;